module.exports = " <div class=vip> <a href=http://vip.koradior.cn/#/ ><img src=" + require("../../../static/images/vip.png") + " alt=\"\"></a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vip/vip.vue
// module id = 70
// module chunks = 1